import { render, staticRenderFns } from "./RecentArticles.vue?vue&type=template&id=b599252e"
import script from "./RecentArticles.vue?vue&type=script&lang=js"
export * from "./RecentArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports